function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1.66,
  y: 9.39,
  width: 60.67,
  height: 45.21,
  rx: 2.37,
  ry: 2.37,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 3.18
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.88 42.81L49.1 35.17a3.68 3.68 0 00-3.52-.17l-8.8 4.33A3.68 3.68 0 0133 39l-9.88-7.16a3.68 3.68 0 00-4.21-.08L1.66 43.38",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 3.18
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.56,
  cy: 23.1,
  r: 5.08,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 3.18
});

function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+aW1hZ2U8L3RpdGxlPjxyZWN0IHg9IjEuNjYiIHk9IjkuMzkiIHdpZHRoPSI2MC42NyIgaGVpZ2h0PSI0NS4yMSIgcng9IjIuMzciIHJ5PSIyLjM3IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMuMTgiLz48cGF0aCBkPSJNNjEuODgsNDIuODEsNDkuMSwzNS4xN0EzLjY4LDMuNjgsMCwwLDAsNDUuNTgsMzVsLTguOCw0LjMzQTMuNjgsMy42OCwwLDAsMSwzMywzOWwtOS44OC03LjE2YTMuNjgsMy42OCwwLDAsMC00LjIxLS4wOEwxLjY2LDQzLjM4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMuMTgiLz48Y2lyY2xlIGN4PSI0My41NiIgY3k9IjIzLjEiIHI9IjUuMDgiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMy4xOCIvPjwvc3ZnPg==";
export { SvgImage as ReactComponent };